import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { DesktopSidebar } from './DesktopSidebar';
import { useIsDesktop } from '../hooks/useMediaQuery';
import { useAuth, useCompany } from '../hooks/useAuth';
import { AppColors } from '../theme/colors';

interface ResponsiveUserLayoutProps {
  children: ReactNode;
  maxWidth?: string | number;
  topFullWidth?: ReactNode;
}

/**
 * 一般ユーザー用のレスポンシブレイアウトコンポーネント
 * PC版: ヘッダー + 固定サイドバー + メインコンテンツ
 * モバイル版: ヘッダー + ドロワーサイドバー + メインコンテンツ
 */
export const ResponsiveUserLayout: React.FC<ResponsiveUserLayoutProps> = ({
  children,
  maxWidth = '800px',
  topFullWidth,
}) => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { user } = useAuth();
  const { company } = useCompany(user?.uid || null);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: AppColors.surface, display: 'flex', flexDirection: 'column' }}>
      {/* ヘッダー（PCのみ表示） */}
      {isDesktop && (
        <Header 
          onMenuClick={() => setDrawerOpen(true)}
          onSettingsClick={() => navigate('/settings')}
          companyName={company?.companyName}
        />
      )}

      {/* モバイル用ドロワー（ヘッダーを表示しないため未使用） */}
      {!isDesktop && null}

      {/* レイアウトコンテナ */}
      <Box sx={{ display: 'flex', flex: 1, pt: isDesktop ? '64px' : 0 }}>
        {/* PC版用固定サイドバー */}
        {isDesktop && <DesktopSidebar />}

        {/* メインコンテンツ */}
        <Box sx={{ 
          flex: 1,
          marginLeft: isDesktop ? '240px' : 0,
          width: isDesktop ? 'calc(100% - 240px)' : '100%',
        }}>
          {topFullWidth && (
            <Box sx={{ width: '100%' }}>
              {topFullWidth}
            </Box>
          )}
          <Box sx={{
            maxWidth: isDesktop ? maxWidth : '100%',
            mx: isDesktop ? 'auto' : 0,
            width: '100%',
            px: isDesktop ? 2 : 0,
          }}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

